import React, { Component, useState,useEffect } from 'react';
import { render } from 'react-dom';
import Map from './Map';
import {
    withScriptjs,
    withGoogleMap,
} from "react-google-maps";

const MapWithInfoBox = (props) => {


    const [isDisplayed, setIsDisplayed] = useState(false);

        setInterval(() => {
            setIsDisplayed(true);
        }, 1000);


    console.log('mapwithinfo');
    const searchLocationData = props.searchLocation;
    const searchLocationInputData = props.searchLocationInput;

    const StyledMapWithAnInfoBox = withScriptjs(withGoogleMap(props => <Map searchLocationData={searchLocationData} searchLocationInputData={searchLocationInputData}/>));
    //const StyledMapWithAnInfoBox = withScriptjs(withGoogleMap(Map));
    //const WrappedMap = withScriptjs(withGoogleMap(props => <Goomap {...props}/>));

    return (

        isDisplayed &&
            <StyledMapWithAnInfoBox
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCv7m-2LTrrKnu1P38xKNBvvFJXoQGAnGg&libraries=places&callback=initMap"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `668px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
            />
          
       
    )
}

export default MapWithInfoBox